import React from "react";
import "./Lawyers.css";

const Lawyers = () => {
 const lawyers = [
  {
    name: "Senior Advocate",
    role: "Civil & Criminal Law",
    exp: "20+ Years Experience",
    desc: "Extensive experience in handling complex civil and criminal cases across various courts.",
    skills: ["High Court Practice", "Supreme Court Matters", "Constitutional Law", "Criminal Defense"],
  },
  {
    name: "Corporate Law Specialist",
    role: "Business & Commercial Law",
    exp: "15+ Years Experience",
    desc: "Expert in corporate legal advisory, mergers & acquisitions, and commercial litigation.",
    skills: ["Company Law", "Contract Law", "Mergers & Acquisitions", "Commercial Disputes"],
  },
  {
    name: "Family Law Expert",
    role: "Family & Matrimonial Law",
    exp: "12+ Years Experience",
    desc: "Handling sensitive family matters with professionalism and care.",
    skills: ["Divorce", "Child Custody", "Adoption", "Domestic Violence"],
  },
  {
    name: "Property Law",
    role: "Real Estate & Property Law",
    exp: "20+ Years Experience",
    desc: "Specialized in property disputes, documentation, and real estate legal matters.",
    skills: ["Property Transactions", "Title Verification", "Land Disputes", "RERA"],
  },
  {
    name: "Criminal Law Specialist",
    role: "Criminal Defense & Litigation",
    exp: "14+ Years Experience",
    desc: "Expert in handling criminal cases, bail matters, and trial proceedings.",
    skills: ["Bail Applications", "Trial Cases", "Criminal Appeals", "Legal Defense"],
  },
  {
    name: "Corporate & Tax Law Expert",
    role: "Taxation & Financial Law",
    exp: "15+ Years Experience",
    desc: "Specialized in Company law, GST, income tax, and corporate compliance.",
    skills: ["GST Law", "Income Tax", "Tax Planning", "Corporate Compliance"],
  },

  // 🌍 International Section
  {
    name: "International Law Specialist",
    role: "International Trade & Business Law",
    exp: "15+ Years Experience",
    desc: "Handling cross-border transactions, international trade laws, and global compliance.",
    skills: ["Trade Agreements", "Import/Export Laws", "Cross-Border Compliance", "International Contracts"],
  },
  {
    name: "IPR & Cyber Law Expert",
    role: "Intellectual Property & Cyber Law",
    exp: "10+ Years Experience",
    desc: "Registration and protection of intellectual property rights and handling cybercrime and digital legal issues.",
    skills: ["Trademarks", "Copyrights, Patents, Geographical indications and others", "Cyber Crime", "Data Protection"],
  },
  {
    name: "Immigration Law Consultant",
    role: "Visa & Immigration Law",
    exp: "10+ Years Experience",
    desc: "Providing legal assistance for visas, residency, and immigration processes.",
    skills: ["Visa Processing", "Work Permits", "Residency", "Immigration Compliance"],
  },
];

  return (
    <div className="lawyers-page">
      <div className="container-fluid">

        {/* Banner */}
        <div className="about_top-3">
          <div className="overlay"></div>
          <div className="glassy-banner-2">
            <h1 className="about-heading-1">Our Legal Practitioners</h1>
          </div>
        </div>

        {/* Section */}
        <section className="lawyers-intro">
          <h2>Our Legal Team</h2>
        </section>

        {/* Cards */}
        <section className="lawyers-grid">
          {lawyers.map((lawyer, index) => (
            <div className="lawyer-card" key={index}>
              <div className="lawyer-info">
                <h2>{lawyer.name}</h2>
                <h3>{lawyer.role}</h3>
                <span className="experience">{lawyer.exp}</span>

                <p>{lawyer.desc}</p>

                <ul className="specializations">
                  {lawyer.skills.map((skill, i) => (
                    <li key={i}>{skill}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </section>

        {/* Team Approach */}
        <section className="team-approach">
          <h2>Our Legal Practitioners</h2>
          <p>
            We follow a collaborative approach where our Our Legal Practitioners work together
            to deliver effective legal solutions. Every case is handled with
            collective expertise, ensuring strong representation and results.
          </p>
        </section>

      </div>
    </div>
  );
};

export default Lawyers;